import * as Styled from './Message.styled';

import { IInboxMessagePreview } from '@trycourier/react-provider';
import { Button } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const formatRelativeTime = (t: Date | string | number): string => dayjs(t).fromNow();

type Props = Readonly<{
  message: IInboxMessagePreview;
  markMessageArchived: (messageId: string, fromWS?: boolean) => Promise<void>;
}>;

export const Message: React.FC<Props> = ({ message, markMessageArchived }) => (
  <Styled.MessageContainer>
    <Styled.MessageBody>
      <Styled.MessageTitle>{message.title}</Styled.MessageTitle>

      {message.actions?.length
        ? message.actions.map((action) => (
          <div key={action.content}>
            <Button
              type='primary'
              href={action.href}
              target='_blank'
            >
              {action.content}
            </Button>
          </div>
        ))
        : message.preview}

      <Styled.MessageDateTime>{formatRelativeTime(message.created)}</Styled.MessageDateTime>
    </Styled.MessageBody>

    <Styled.MessageAction>
      <Styled.MessageActionDelete>
        <Styled.TrashCanIcon data-testid='message.delete-action.icon' onClick={() => markMessageArchived(message.messageId)} />
      </Styled.MessageActionDelete>
    </Styled.MessageAction>
  </Styled.MessageContainer>
);
